import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { EntityState } from '@api/models/enums/EntityState';
import { WorkplaceDto } from '@api/models/workplace/WorkplaceDto';
import { workplaceService } from '@api/services/services';

type State = BaseType<Partial<WorkplaceDto>>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    nameEn: '',
    establishment: undefined,
    riskRequired: false,
    risks: [],
    safetyEquipments: [],
    state: EntityState.Active,
    note: '',
    notifyEmployees: []
  },
};

export const workplaceSlice = baseSlice({
  name: 'workplace',
  initialState,
});

export const selectWorkplaceState = (state: RootState) => state.workplace.state;
export const selectWorkplace = (state: RootState) => state.workplace.data;
export const workplaceActions = workplaceSlice.actions;

export const getWorkplace =
  (workplaceId: string) => (dispatch: AppDispatch) => {
    const handleGetData = () => {
      return workplaceService.getById(workplaceId);
    };

    getItem({
      dispatch,
      actions: workplaceActions,
      getData: handleGetData,
    });
  };
